<template>
  <div>
    <div>
      <router-view></router-view>
    </div>
    <label class="avatar pointer">
        <div class="photo" v-if="authAvatar" :style="{
                      backgroundImage: `url(${staticUrl}${authAvatar})`
                    }"></div>
        <div class="py-4 px-2" v-else><user-icon></user-icon></div>
        <input type="file" @change="handleFileChange" />
    </label>
    <h4 class="username text-nowrap">{{ authName }}</h4>
    <div class="foot">
      <router-link
        to="profile/personal-info"
        class="btn btn-block profile-btn text-primary p-3"
        :disabled="loading"
      >
        {{ $t("personal-info") }}
        <personal-info-icon></personal-info-icon>
      </router-link>
      <router-link
        to="profile/contact-info"
        class="btn btn-block profile-btn text-primary p-3 disabled"
        :disabled="loading"
      >
        {{ $t("contact-info") }}
        <contact-info-icon></contact-info-icon>
      </router-link>
      <router-link
        to="profile/password"
        class="btn btn-block profile-btn text-primary p-3"
        :disabled="loading"
      >
        {{ $t("change-password") }}
        <password-icon></password-icon>
      </router-link>
      <a
        class="btn btn-block profile-btn p-3"
        :disabled="loading"
        @click.prevent="logout"
      >
        {{ $t("logout") }}
        <logout-icon></logout-icon>
      </a>
    </div>
  </div>
</template>
<script>
import LogoutIcon from '@/components/Icons/Logout'
import UserIcon from '@/components/Icons/User'
import PersonalInfoIcon from '@/components/Icons/PersonalInfo'
import ContactInfoIcon from '@/components/Icons/ContactInfo'
import PasswordIcon from '@/components/Icons/Password'
import { mapMutations, mapGetters, mapActions } from 'vuex'
export default {
  components: {
    LogoutIcon,
    UserIcon,
    PersonalInfoIcon,
    ContactInfoIcon,
    PasswordIcon
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      staticUrl: 'app/staticUrl',
      authAvatar: 'auth/avatar',
      authName: 'auth/name'
    })
  },
  mounted () {
    this.setNavVisible(false)
    this.setHead({ url: '/dashboard', text: this.$t('myProfile') })
  },
  destroyed () {
    this.resetHead()
  },
  methods: {
    ...mapMutations({
      setToken: 'auth/setToken',
      setUser: 'auth/setUser',
      setHead: 'head/set',
      resetHead: 'head/reset',
      setError: 'auth/setError',
      setNavVisible: 'app/setNavVisible'
    }),
    ...mapActions({
      authFetch: 'auth/fetch'
    }),
    handleFileChange (e) {
      const file = e.target.files[0]
      this.uploadAvatar(file)
    },
    async uploadAvatar (file) {
      try {
        const formData = new FormData()
        formData.append('file', file)
        await this.axios.post(
          '/api/profile/avatar',
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )
        this.authFetch()
      } catch (err) {
        this.setError(err)
      }
    },
    logout () {
      this.$store.commit('auth/setToken', null)
      this.$store.commit('auth/setUser', null)
      this.$cookie.delete('session')
      window.location.href = '/'
      // this.$router.push({ name: 'Login' })
    }
  }
}
</script>
<style lang="scss">
.profile {
  .username {
    position: absolute;
    left: 50%;
    top: calc(25% + 100px);
    transform: translate(-50%, -50%);
  }
  .avatar {
    position: absolute;
    left: 50%;
    top: 25%;
    transform: translate(-50%, -50%);
    width: 140px;
    height: 140px;
    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    border-radius: 70px;
    overflow: hidden;
    .photo {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
    }
    input[type="file"] {
      display: none;
    }
  }
  .foot {
    position: absolute;
    bottom: 0;
    width: 100%;
    .profile-btn {
      margin: 0;
      border-top: 1px solid #e3e3e3;
      display: flex;
      justify-content: space-between;
      &:hover {
        background-color: #eee;
      }
      svg {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
<i18n>
{
  "ka": {
      "myProfile": "ჩემი პროფილი",
      "logout": "გამოსვლა",
      "personal-info": "პირადი ინფორმაცია",
      "contact-info": "საკონტაქტო ინფორმაცია",
      "change-password": "პაროლის შეცვლა"
  }
}
</i18n>
